<template>
  <div class="page-container">
    <div class="query-title">经销商开票量使用明细表</div>

    <div class="content">
      <QueryParams ref="QueryParams" limitSearchLength="4" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template #button>
            <table-button name="export" tip="导出" @click="downloadTemplateByRear('经销商开票量使用明细表')" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          >
          <template #netValue="{row}">
            <div style="text-align: right">{{ row.netValue ? row.netValue.toFixed(2) : '' }}</div>
          </template>
          <template #totalTax="{row}">
            <div style="text-align: right">{{ row.totalTax ? row.totalTax.toFixed(2) : '' }}</div>
          </template>
          <template #netPrice="{row}">
            <div style="text-align: right">{{ row.netPrice ? row.netPrice.toFixed(2) : '' }}</div>
          </template>
          <template #tons="{row}">
            <div style="text-align: right">{{ row.tons ? row.tons.toFixed(4) : '' }}</div>
          </template>
        </vxe-grid>
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />

  </div>
</template>

<script>
import { getDealerInvUseDtlReport, apiExportExceldealerMakeInvoiceInfoDatas } from '@/api/applyForGoods/index'
import tableMixins from '@/utils/tableMixins'
import pageConfig,{ pageSearch } from './config/dealersMakeInvoiceUsedReportForms'
import { frontExport, concurrencyReq } from '@/utils/frontExport'
import { getToken } from '@/utils/auth'
import { DOWNLOAD_API } from '@/api/baseUrl'
export default {
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [],
        data: []
      },
      searchField: {},
      isSetFilter: false,
      pageSearch
    }
  },
  created() {
    this.initPage(pageConfig)
  },
  methods: {
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        is_result: 1,
        sort: this.sortData.concat(this.tableSort)
      }

      this.loading = true
      try {
        const { data: { Rows, Total }, calculation, field } = await getDealerInvUseDtlReport(params)
        if (Rows.length === 0 && (Total - 0)) {
          this.queryData(1, ranges)
          return
        }

        this.pagination.totalCount = Total - 0
        this.calculation = this.filtercalculation(calculation, 'xTable', true)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(Rows)
        } else {
          this.gridOptions.data = Rows.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field, 'xTable', true)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    // 导出全部 导出本页
    async exportExcel() {
      const params = {
        ...this.ranges
      }
      const data = await concurrencyReq(this.pagination.totalCount, params, getDealerInvUseDtlReport)
      frontExport(this.gridOptions.columns, data, '经销商开票量使用明细表')
    },

    // 后端导出 下载
    async downloadTemplateByRear(fileName) {
      // alert(type)
      const params = {
        templateCode:'makeInvoiceInfo',
        ...this.allConditions
      }

      const res = await apiExportExceldealerMakeInvoiceInfoDatas(params)

      if (res?.status !== 0) {
        return
      }

      const url = `${DOWNLOAD_API()}/attachment/downFileByTmpdir.ajax?file=${
        res.data.file
      }&authToken=${getToken()}&fileName=${fileName}`
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      // link.target = '_blank'
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/report-forms-manage/dealersMakeInvoiceUsedReportForms.vue